export const safeJSONParse = <T>(str: string, fallback: T | null = null): T | null => {
  try {
    return JSON.parse(str) as T;
  }
  // eslint-disable-next-line unused-imports/no-unused-vars
  catch (error) {
    return fallback;
  }
}
